import { Component } from "@angular/core";

@Component({
  selector: "app-no-role-page",
  templateUrl: "./no-role-page.component.html",
  styleUrls: ["./no-role-page.component.scss"]
})
export class NoRolePageComponent { }
